/** @format */

import { memo } from 'react'
import { CopyBlock, shadesOfPurple } from 'react-code-blocks'

import styles from 'dir/styles/courses.module.css'

export const _2 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>2 - CSS-тени</h2>
    <p className={styles.description}>
      Тень под текстом или элементом обычно применяется для создания эффекта трёхмерности, привлечения внимания к
      элементу или как часть дизайна. Небольшая тень под элементами придаёт также странице объём и глубину.{' '}
    </p>
    <section className={styles.subsection}>
      <h3 className={styles.h3}>2.1 - text-shadow</h3>
      <p className={styles.description}>
        Свойство <code className={styles.code}>text-shadow</code> используется для добавления тени к тексту. Тень текста
        позволяет создавать удивительные эффекты. Тени могут быть однослойными или многослойными, размытыми, цветными
        или полупрозрачными.{' '}
      </p>
      <p className={styles.description}>
        Каждая тень применяется как к самому тексту, так и к элементам его оформления. Одновременно можно задавать
        несколько теней, указывая их через запятую. Тени накладываются друг на друга, не перекрывая сам текст. Первая
        тень всегда расположена сверху над остальными тенями. Свойство <code className={styles.code}>text-shadow</code>{' '}
        наследуется.{' '}
      </p>
      <p className={styles.description}>
        Каждая тень определяется двумя или тремя значениями и цветом. Если цвет тени не указан, используется цвет
        текста.{' '}
      </p>
      <CopyBlock
        text={`text-shadow: x-offset y-offset blur color;`}
        language="html"
        showLineNumbers
        theme={shadesOfPurple}
      />
      <ul className={styles.list}>
        <li className={styles.list__item}>
          <code className={styles.code}>x-offset</code> - смещение тени по горизонтали относительно текста. Может
          принимать как положительные, так и отрицательные значения. Обязательное значение.{' '}
        </li>
        <li className={styles.list__item}>
          <code className={styles.code}>y-offset</code> - смещение тени по вертикали относительно текста. Может
          принимать как положительные, так и отрицательные значения. Обязательное значение.{' '}
        </li>
        <li className={styles.list__item}>
          <code className={styles.code}>blur</code> - определяет радиус размытия тени. Чем больше радиус, тем сильнее
          размыта тень. Необязательное значение.{' '}
        </li>
        <li className={styles.list__item}>
          <code className={styles.code}>color</code> - по умолчанию принимает цвет текста. Для значения можно
          использовать <code className={styles.code}>hex</code>, <code className={styles.code}>rgb</code>,{' '}
          <code className={styles.code}>rgba</code> форматы записи цвета. Необязательное значение.
        </li>
      </ul>
      <p className={styles.notificationWarn}>
        Если значения длин отрицательные, то тень смещается влево и вверх от текста.
      </p>
    </section>
    <section className={styles.subsection}>
      <h3 className={styles.h3}>2.2 - box-shadow</h3>
      <p className={styles.description}>
        Свойство <code className={styles.code}>box-shadow</code> добавляет элементу одну или более теней. Тени бывают
        внешние или внутренние, размытые или плоские, они могут следовать контурам блоков со скругленными углами. С
        помощью ключевого слова inset создаются тени внутри элемента, делая элемент визуально объёмным или вдавленным.{' '}
      </p>
      <p className={styles.description}>Каждая тень принимает от одного до пяти параметров: </p>
      <CopyBlock
        text={`box-shadow: inset x-offset y-offset blur spread color;`}
        language="html"
        showLineNumbers
        theme={shadesOfPurple}
      />
      <ul className={styles.list}>
        <li className={styles.list__item}>
          <code className={styles.code}>x-offset</code> - смещение тени по горизонтали относительно блока. Может
          принимать как положительные, так и отрицательные значения, положительное смещает тень вправо от блока,
          отрицательное – влево. Обязательное значение.{' '}
        </li>
        <li className={styles.list__item}>
          <code className={styles.code}>y-offset</code> - смещение тени по вертикали относительно блока. Может принимать
          как положительные, так и отрицательные значения, положительное смещает тень вниз, отрицательное — вверх.
          Обязательное значение.{' '}
        </li>
        <li className={styles.list__item}>
          <code className={styles.code}>blur</code> - определяет радиус размытия тени. Чем больше радиус, тем сильнее
          размыта тень. Можно использовать только положительные значения. Необязательное значение.{' '}
        </li>
        <li className={styles.list__item}>
          <code className={styles.code}>spread</code> - расширяет тень, утолщая ее. Принимает как положительные, так и
          отрицательные значения. Необязательное значение.{' '}
        </li>
        <li className={styles.list__item}>
          <code className={styles.code}>color</code> - Необязательное значение. По умолчанию тень черного цвета. Для
          установления значения можно использовать hex, rgb, rgba форматы записи цвета.
        </li>
        <li className={styles.list__item}>
          <code className={styles.code}>inset</code> - создаёт тень внутри блока.
        </li>
      </ul>
    </section>
  </section>
))
